<template>
  <a-card :bordered="false">
    <a-button type="primary" style="margin-left: 8px" @click="handleExport"
      >导出</a-button
    >
    <s-table size="default" :columns="columns" :data="loadData">
      <template slot="render_user" slot-scope="text, record">
        {{ record.type < 2 ? record.user_name : record.admin_user_name }}
      </template>
      <template slot="type" slot-scope="text">
        {{ text | typeMapFilter }}
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getStockRecord } from "@/api/stock";
import { encodeJsonToQuery } from "@/utils/util";
import { ACCESS_TOKEN } from "@/store/mutation-types";

export default {
  name: "StockDetail",
  components: {
    STable,
  },
  data() {
    return {
      mdl: [],
      columns: [
        {
          title: "归属单号",
          dataIndex: "order_no",
        },
        // {
        //   title: "商品名称",
        //   dataIndex: "goods_name",
        // },
        // {
        //   title: "所属门店",
        //   dataIndex: "branch_name",
        // },
        {
          title: "变动数量",
          dataIndex: "change_quantity",
        },
        {
          title: "库存余额",
          dataIndex: "remainder",
        },
        {
          title: "变动原因",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        {
          title: "库存变动操作人",
          dataIndex: "user_name",
          scopedSlots: { customRender: "render_user" },
        },
        {
          title: "操作时间",
          dataIndex: "created",
        },
        {
          title: "备注",
          dataIndex: "remarks",
        },
      ],
      loadData: (params) => {
        return getStockRecord({ ...params, id: this.$route.params.id }).then(
          (res) => res
        );
      },
    };
  },
  methods: {
    handleExport: function () {
      const params = {
        id: this.$route.params.id,
        token: this.$ls.get(ACCESS_TOKEN),
      };
      window.open(
        `/api/admin/stock/${
          this.$route.params.id
        }/record/excel${encodeJsonToQuery(params)}`
      );
    },
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}
.pic > img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
